(ns app.front.view.admin.excise.data-import
  (:require [app.front.ui.table :as ui-table]
            [app.front.view.admin.excise.common :as excise-common]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub]]
            [core.front.href :as href]
            [core.util.util :as util]))

(defmethod excise-common/data-select :excise.type/import-sessions [type]
  (let [tr (<sub [:tr])]
    [ui-table/modern-responsive-table
     {:items (<sub [::excise-common/selectable-candidates])
      :link  {:make-href   (fn [{:keys [:db/id]}]
                             (href/href :view/admin.excise.perform (util/mmap {:type (name type)} id)))
              :description "Select import session to excise"}
      :cols  [["Session date" (comp (<sub [::date-util/date-time-fn]) :entity/created)]
              ["Group" (comp :group/name :domain/authority-group)]
              ["Import type" (comp tr vector :import-session/type)]]}]))
